import { atom } from 'jotai'

export type EventJoinedType = {
  medicalRecordId: string
  id: number
}

export const isVideoCallingAtom = atom<boolean>(false)

export const eventJoinedAtom = atom<EventJoinedType | undefined>(undefined)
